import React from 'react'
import cx from 'classnames'
import { Droppable } from 'react-beautiful-dnd'
import Card from './Card'

import '../stylesheets/components/Column.scss'

class Column extends React.Component {
    render() {
        return (
            <div
                className={cx('Column', { caption: this.props.caption })}
                style={{ width: `${100 / (this.props.columns.length + 1)}%` }}>
                <div className="Column_fix">
                    <div className="Column_title" />
                    <Droppable isDropDisabled={false} droppableId={'drop' + this.props.column.id}>
                        {(provided) => (
                            <div
                                className="Column_container"
                                {...provided.droppableProps}
                                ref={provided.innerRef}>
                                <div className="Column_scroll">
                                    <div className="Column_area"></div>
                                    <div className="Column_holder">
                                        {this.props.column.cards.map((card, key) => (
                                            <Card
                                                key={key}
                                                card={card}
                                                index={key}
                                                caption={this.props.caption}
                                            />
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                </div>
                            </div>
                        )}
                    </Droppable>
                </div>
            </div>
        )
    }
}

export default Column
